import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import LumenButton from "../ui/LumenButton";
import "./LumenNavbar.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../authContext";

const LumenNavbar: React.FC = () => {
  const [show, setShow] = useState(false);
  const toggle = () => setShow((s) => !s);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const { isAuthenticated } = useAuth();

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const el: HTMLElement | Window =
      (document.getElementById("wrapper") as HTMLElement) || window;

    const getTop = () =>
      el === window ? window.scrollY : (el as HTMLElement).scrollTop || 0;

    const onScroll = () => setScrolled(getTop() > 0);

    onScroll();
    if (el === window) {
      window.addEventListener("scroll", onScroll, { passive: true });
    } else {
      (el as HTMLElement).addEventListener("scroll", onScroll, {
        passive: true,
      });
    }

    return () => {
      if (el === window) {
        window.removeEventListener("scroll", onScroll);
      } else {
        (el as HTMLElement).removeEventListener("scroll", onScroll);
      }
    };
  }, [location.pathname]); // re-evaluate on route change

  return (
    <Navbar
      expand="lg"
      className={`lumen-navbar ${isHome ? "is-home" : ""} ${scrolled ? "scrolled" : ""}`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="lumen-brand">
          Lumen@home
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="lumen-offcanvas"
          onClick={toggle}
          className="border-0 shadow-none ms-auto"
        />

        <Navbar.Collapse id="lumen-navbar">
          <Nav
            className="ms-auto align-items-center d-none d-lg-flex"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <Nav.Link as={NavLink} to="/" className="lumen-nav-link">
              Naslovna
            </Nav.Link>
            <Nav.Link as={NavLink} to="/o-nama" className="lumen-nav-link">
              O nama
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/pripreme-za-maturu"
              className="lumen-nav-link"
            >
              Pripreme
            </Nav.Link>
            <Nav.Link as={NavLink} to="/poduke" className="lumen-nav-link">
              Poduke
            </Nav.Link>
            <Nav.Link as={NavLink} to="/nastavnici" className="lumen-nav-link">
              Nastavnici
            </Nav.Link>
            <Nav.Link as={NavLink} to="/cjenik" className="lumen-nav-link">
              Cjenik
            </Nav.Link>

            <div className="ms-3">
              <LumenButton
                to={isAuthenticated ? "/dashboard" : "/prijava"}
                size="sm"
                variant="ghost-red"
              >
                {isAuthenticated ? "DASHBOARD" : "LOGIN"}
              </LumenButton>
            </div>
          </Nav>
        </Navbar.Collapse>

        <Offcanvas
          show={show}
          onHide={() => setShow(false)}
          placement="end"
          id="lumen-offcanvas"
          className="lumen-offcanvas d-lg-none"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="lumen-brand">
              Lumen@home
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="flex-column">
              <Nav.Link
                as={NavLink}
                to="/"
                onClick={() => setShow(false)}
                className="lumen-nav-link"
                end
              >
                Naslovna
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/o-nama"
                onClick={() => setShow(false)}
                className="lumen-nav-link"
              >
                O nama
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/pripreme-za-maturu"
                onClick={() => setShow(false)}
                className="lumen-nav-link"
              >
                Pripreme
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/poduke"
                onClick={() => setShow(false)}
                className="lumen-nav-link"
              >
                Poduke
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/nastavnici"
                onClick={() => setShow(false)}
                className="lumen-nav-link"
              >
                Nastavnici
              </Nav.Link>
              <Nav.Link
                as={NavLink}
                to="/cjenik"
                onClick={() => setShow(false)}
                className="lumen-nav-link"
              >
                Cjenik
              </Nav.Link>
              <div className="mt-3">
                <LumenButton
                  to={isAuthenticated ? "/dashboard" : "/prijava"}
                  block
                  variant="ghost-red"
                  onClick={() => setShow(false)}
                >
                  {isAuthenticated ? "Dashboard" : "Login"}
                </LumenButton>
              </div>
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    </Navbar>
  );
};

export default LumenNavbar;
